import {
  TELEMETRY_SITE_SLUGS,
  type TelemetrySiteSlug
} from "../telemetry/contract";
import type { SiteOption } from "../types";

const TELEMETRY_SITE_SLUG_SET = new Set<string>(TELEMETRY_SITE_SLUGS);

export function telemetrySiteSlugFromCanonicalSlug(
  slug: string
): TelemetrySiteSlug | null {
  return TELEMETRY_SITE_SLUG_SET.has(slug) ? (slug as TelemetrySiteSlug) : null;
}

export function telemetrySiteSlugForSite(
  site: SiteOption | null | undefined
): TelemetrySiteSlug | null {
  return site === null || site === undefined
    ? null
    : telemetrySiteSlugFromCanonicalSlug(site.canonical_site_slug);
}

export function isTelemetryEligibleSite(
  site: SiteOption | null | undefined
): boolean {
  return telemetrySiteSlugForSite(site) !== null;
}
